import type { AxiosError } from "axios";
import Axios from "axios";
import React, { useContext, useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import styled, { useTheme } from "styled-components/macro";
import {
  ButtonWithWarningDialog,
  SVGButtonProps,
} from "../../../components/Buttons/Buttons";
import {
  ButtonWithConfirmDialog,
  CancelButton,
  CancelTransactionDialogButton,
  LinkButtonLargeV2,
  PrimaryButtonFitContainer,
  PrimaryButtonMedium,
  GhostButtonMediumV2,
  EditButton,
  PrimaryButtonMediumV2,
  PrimaryButtonWithPlusIcon,
  PrimaryButtonLargeV2,
} from "../../../components/Buttons/Buttons";
import { ContactInfoBlockSmall } from "../../../components/ContactInfoBlockSmall/ContactInfoBlockSmall";
import { IDDesktop } from "../../../components/IDs/IDs";
import {
  HeaderLeft,
  HeaderRight,
  Row,
} from "../../../components/Layout/Layout";
import {
  H3,
  InnerTitle,
  SoftHeader,
  SoftHeaderPrimaryTextColor,
} from "../../../components/Typography/Typography";
import { Flex, Form } from "../../../layout/FormLayout";
import {
  Card,
  PageHeader,
  PageTitle,
  PageWrapper,
  TwoColumnOrderTotalSection,
} from "../../../layout/portalPageLayout";
import type {
  AccountManagerContactInfo,
  CurrencyCode,
  DataMutate,
  Fee,
  IAddress,
  IFeesAndChargesSchema,
  IShipmentAdvice,
  ITenantCustomerSettings,
  OptionType,
  PaginatedTransactionEvents,
  ProductSKU,
  SampleDocument,
  SampleRequest,
  SampleRequestDetail,
  SampleRequestNextStatusSchema,
  SampleRequestStatus,
  SampleStatusLabel,
  UUID,
  User,
} from "../../../types/types";
import { Notifications } from "../../../components/Notifications/NotificationsContext";
import { endpoints } from "../../../endpoints";
import {
  DetailPageContentWrapper,
  KeyValueContainer,
  QuoteOrderContent,
  QuoteTermsContainer,
  TimelineWrapper,
  WideDetails,
} from "../../../layout/shared/DetailPageLayout/DetailPageLayout";
import { useRoutePath } from "../../../util/Routing";
import {
  convertDeliveryTermToOption,
  convertPaymentModeToOption,
  convertPaymentTermToOption,
  convertSampleLabelToSampleStatus,
  convertSampleStatusToSampleLabel,
  convertSampleStatusToSampleStatusAction,
  formatDateTime,
  MISSING_CURRENCY_SYMBOL,
  useCurrency,
  useFormWrapper,
  useStoreState,
} from "../../../util/util";
import { SampleRequestStatusLabel } from "../SampleRequestListPage/SampleRequestListPage";
import {
  ActiveWarningMessage,
  HorizontalSeparator,
  NotificationContainer,
} from "../SellerQuoteDetailPage/SellerQuoteDetailPageContent";
import { Auth, useAuthContext } from "../../../components/Auth";
import { SampleRequestItem } from "../../../components/TransactionItem/SampleRequestItem";
import { ShipmentAdviceSection } from "../../../components/ShipmentAdviceSection/ShipmentAdviceSection";
import { SellerCreateOrEditShipmentAdvice } from "../../../components/SellerCreateOrEditShipmentAdvice/SellerCreateOrEditShipmentAdvice";
import { useTranslation } from "react-i18next";
import { SlideOut } from "../../../components/SlideOut/SlideOut";
import {
  ArrayParam,
  NumberParam,
  StringParam,
  useQueryParams,
} from "use-query-params";
import useSWR from "swr";
import {
  TransactionStatusPath,
  isPartManualSampleStatusChanges,
} from "../../../components/OrderStatusPath/OrderStatusPath";
import { ConfirmDialog } from "../../../components/ConfirmDialog/ConfirmDialog";
import { DropDown } from "../../../components/DropDown/DropDown";
import { Timeline } from "../../../components/Timeline/Timeline";
import { AddDocumentToTransaction } from "../AddDocumentToTransaction/AddDocumentToTransaction";
import { TransactionsDocumentView } from "../../../components/DocumentView/TransactionsDocumentView";
import { get_existing_documents } from "../AddDocumentToTransaction/utils";
import { yupResolver } from "@hookform/resolvers/yup";
import { positiveIntegerRegex } from "../../../util/regexes";
import { strings } from "../../../util/strings";
import * as yup from "yup";
import {
  ItemDetailRecord,
  SampleRequestItemCardSellerResponding,
} from "../../../components/TransactionItem/SampleRequestItemCardSellerResponding";
import type { CustomSkuData } from "../SellerQuoteDetailPage/AddCustomSkuForm";
import { TransactionSplitForm } from "../../../components/TransactionSplitForm/TransactionSplitForm";
import { CheckBoxNoLabel } from "../../../components/CheckBoxes/CheckBoxes";
import axios from "axios";
import {
  CaretLeft,
  ExternalLinkIcon,
  WarningIcon,
} from "../../../components/Icons/Icons";
import type { ColumnDef } from "@tanstack/react-table";
import { spacingTokens } from "../../../designTokens";
import { FormProvider } from "react-hook-form";
import { ToggleSwitchV2 } from "../../../components/ToggleSwitch/ToggleSwitch";
import type { KeyValuePair } from "../../../components/KeyValueDisplay";
import { KeyValueDisplay } from "../../../components/KeyValueDisplay";
import {
  PriceDetails,
  calculatePriceDetails,
} from "../../../components/PriceDetails/PriceDetails";
import { PriceDetailsColumn } from "../../Buyer/BuyerQuoteDetail/BuyerQuoteDetail";
import {
  get_fees_list,
  sampleRequestIsPriced,
} from "../../../util/sampleRequestPayments";
import moment from "moment";
import { CreateSampleTermsForm } from "../../Seller/SellerCreateSampleRequest/CreateSampleBottomForm";
import { EditSubtotal } from "../../../components/EditSubtotal/EditSubtotal";
import { InvoiceSection } from "../SellerOrderDetailPage/InvoiceSection/InvoiceSection";
import { DisplayOrEditLotNumbers } from "../../../components/DisplayAndEditLotNumbers/DisplayLotNumbers";
import { TransactionNotes } from "../../../components/TransactionNotes/TransactionNotes";
import { PoNumberAndDocumentLink } from "../../../components/PoNumberAndDocumentLink/PoNumberAndDocumentLink";
import { AddPO } from "../../Buyer/BuyerOrderDetail/AddPO";
import { PackingListSection } from "../SellerOrderDetailPage/PackingList/PackingList";
import { AddProductToSampleRequest } from "../../../components/AddProductToTransaction/AddProductToSampleRequest";
import { calculateTotalQuantity } from "../../../components/quoteCart/BuyerQuoteItemForm";
import ReactTooltip from "react-tooltip";

const ItemsContainer = styled.div`
  margin: ${({ theme }) => theme.resolve("spacing_2xl")} 0;
`;

const ButtonRow = styled(Row)`
  margin-top: ${({ theme }) => theme.resolve("spacing_5xl")};
`;

const SampleRequestContent = QuoteOrderContent;

const StatusContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: space-between;
  position: relative;
  & > div[class*="order_status"] {
    position: relative;
    top: -6px;
    min-width: 140px;
  }
`;

const WarningText = styled.span`
  color: ${({ theme }) => theme.warningTextColor};
  display: block;
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  padding-top: ${({ theme }) => theme.resolve("spacing_xs")};
`;

function getModeFromStatus(
  status: Omit<SampleRequestStatus, "new">
): "seller_complete" | "seller_responding" {
  switch (status) {
    case "requested":
    case "new":
    case "pending":
    case "pending_activation":
      return "seller_responding";
    default:
      return "seller_complete";
  }
}

type SampleresponseForm = {
  delivery_term: OptionType;
  payment_term: OptionType;
  payment_method: OptionType;
  valid_to_date?: string;
  required_eta?: string;
} & {
  /**
   * We dynamically generate the (string) keys for the quote item inputs at
   * runtime, for example:
   *   "sku_92ebf76a-552a-48d4-a0ea-8248fab8eff7": OptionType<string>
   *   "number_of_units_92ebf76a-552a-48d4-a0ea-8248fab8eff7": string
   *   "price_per_unit_92ebf76a-552a-48d4-a0ea-8248fab8eff7": string
   *   "sku_7486c6e2-dc51-4958-bc31-e00399046d04: OptionType<string>
   *   "number_of_units_7486c6e2-dc51-4958-bc31-e00399046d04: string
   *   "price_per_unit_7486c6e2-dc51-4958-bc31-e00399046d04: string
   */
  // `undefined` is in here because price_per_unit can be undefined if there
  // are price tiers and in any case if you use the wrong string as a key you
  // get undefined.
  [id: string]:
    | string
    | OptionType<ProductSKU>
    | OptionType<CustomSkuData>
    | undefined;
};
const makeInputIdSku = (id: string) => `sku_${id}`;
const makeInputIdCustomSku = (id: string) => `custom_sku_${id}`;
const makeInputIdNumberOfUnits = (id: string) => `number_of_units_${id}`;
const makeInputIdPricePerUnit = (id: string) => `price_per_unit_${id}`;

/**
 * Used to calculate the subtotal for seller responding or seller editing cases.
 * Add up the total price values for each item, omitting any that are null.
 */
function calculateSubtotal(itemDetailRecord: ItemDetailRecord) {
  const subtotal = Object.values(itemDetailRecord).reduce<number>(
    (result, itemDetail) => {
      return itemDetail.totalPrice ? result + itemDetail.totalPrice : result;
    },
    0
  );
  return subtotal;
}

/**
 * Content for sample request detail pages.
 */

export const SampleRequestDetailPageContent = ({
  sampleRequest,
  mutateSampleRequest,
  fees_and_charges_map,
}: {
  sampleRequest: SampleRequest;
  fees_and_charges_map?: Record<string, IFeesAndChargesSchema>;
  mutateSampleRequest: DataMutate<SampleRequest>;
}) => {
  const {
    storefront_id,
    storefront_metadata: {
      enable_payments_on_sample_requests,
      accepts_payments,
    },
  } = useStoreState();
  const { notifyError, notifySuccess } = useContext(Notifications);
  const { accountPath } = useRoutePath();
  const [query] = useQueryParams({
    q: StringParam,
    offset: NumberParam,
    perPage: NumberParam,
    status: ArrayParam,
    account_manager: ArrayParam,
    customer_service_reps: ArrayParam,
  });
  const [showSplitSampleForm, setShowSplitSampleForm] = useState(false);
  const [showAddProductForm, setShowAddProductForm] = useState(false);
  const { roleIsSomeKindOfBuyer, roleIsSomeKindOfSeller } = useContext(Auth);

  const { t } = useTranslation();

  const [showShipmentAdviceForm, setShowShipmentAdviceForm] = useState(false);

  const [showAddDocumentForm, setShowAddDocumentForm] = useState(false);

  const [adviceToEdit, setAdviceToEdit] =
    useState<IShipmentAdvice | undefined>(undefined);

  const [showStatusChangeDialogBox, setShowStatusChangeDialogBox] =
    useState(false);

  const [selectedSampleStatus, setSelectedSampleStatus] =
    useState<SampleRequestStatus>();

  const [is_splitting_sample, set_is_splitting_sample] = useState(false);

  const [is_cancelling_transaction, set_is_cancelling_transaction] =
    useState(false);
  const [is_resuming_transaction, set_is_resuming_transaction] =
    useState(false);

  const { data: customerSettings } = useSWR<ITenantCustomerSettings>(
    sampleRequest.seller_id && sampleRequest.buyer_id
      ? endpoints.v1_storefronts_id_tenants_id_customers_id_settings(
          storefront_id,
          sampleRequest.seller_id,
          sampleRequest.buyer_id
        )
      : null
  );

  const methodsOfUseForm = useFormWrapper({
    defaultValues: {
      feesList: get_fees_list(fees_and_charges_map, sampleRequest.fees ?? []),
    },
  });

  const { register, setValue, reset: resetFeesForm } = methodsOfUseForm;
  const theme = useTheme();

  const { user } = useAuthContext();
  const history = useHistory();

  const mode: "seller_responding" | "seller_complete" = getModeFromStatus(
    sampleRequest.status
  );
  const isBuyerSubmittedPricedSample =
    sampleRequest.created_by_company_name === sampleRequest.buyer_company_name;
  const sellerResponding = mode === "seller_responding";
  const sellerComplete = mode === "seller_complete";
  const isNewSample =
    sampleRequest.status === "new" && !sampleRequest.status.includes("pending");
  const [editing, setEditing] = useState(false);
  const [enablePayments, setEnablePayments] = useState(
    enable_payments_on_sample_requests
  );
  const [showEditLotNumber, setShowEditLotNumber] = useState(false);
  const [itemDetailRecord, setItemDetailRecord] = useState<
    Record<string, { totalPrice: number | null; hasPriceTiers: boolean }>
  >({});
  const [isAcceptingPrice, setIsAcceptingPrice] = useState(false);
  const [paymentInProcess, setPaymentInProcess] = useState(false);

  const isPendingStatus =
    sampleRequest.status === "pending" ||
    sampleRequest.status === "pending_activation";

  const isPendingActivation = sampleRequest.status === "pending_activation";

  const requiresPaymentTerms = enablePayments && !isPendingActivation;

  const formSchema = useMemo(() => {
    return yup.object().shape({
      feesList: yup.array(
        yup.object().shape({
          name: yup.string(),
          amount: yup
            .number()
            .min(0, t("Must be an integer value"))
            .typeError(strings(t).thisIsARequiredField)
            .required(strings(t).thisIsARequiredField),
        })
      ),
      ...(requiresPaymentTerms && {
        payment_term: yup
          .object({ value: yup.string().required() })
          .required(t("Payment term is required")),
        payment_method: yup
          .object({ value: yup.string().required() })
          .required(t("Payment method is required")),
        delivery_term: yup
          .object({ value: yup.string().required() })
          .required(t("Delivery term is required")),
        valid_to_date: yup
          .string()
          .required(t("Price valid until is required")),
        required_eta: yup.string().required(t("Shipment ETA is required")),
      }),
      ...sampleRequest.items.reduce<Record<string, unknown>>((result, item) => {
        if (requiresPaymentTerms) {
          result[makeInputIdPricePerUnit(item.id)] = yup
            .string()
            .required(strings(t).thisIsARequiredField)
            .test(
              "is-positive",
              t("Must be a positive value"),
              (value) => !value || parseFloat(value) > 0
            );
          result[makeInputIdNumberOfUnits(item.id)] = yup
            .string()
            .required(strings(t).thisIsARequiredField)
            .matches(positiveIntegerRegex, t("Must be an integer value"));
          result[makeInputIdSku(item.id)] = yup
            .object()
            .required(strings(t).thisIsARequiredField);
        }

        return result;
      }, {}),
    });
  }, [t, sampleRequest.items, requiresPaymentTerms]);

  const defaultValues = useMemo(
    () => ({
      delivery_term: convertDeliveryTermToOption(sampleRequest.delivery_term),
      payment_term: convertPaymentTermToOption(sampleRequest.payment_term),
      payment_method: convertPaymentModeToOption(sampleRequest.payment_method),
      required_eta: sampleRequest.required_eta,
      valid_to_date: sampleRequest.valid_to_date,
    }),
    [
      sampleRequest.delivery_term,
      sampleRequest.payment_method,
      sampleRequest.payment_term,
      sampleRequest.required_eta,
      sampleRequest.valid_to_date,
    ]
  );

  const methodsOfUseFormUpdate = useFormWrapper({
    resolver: yupResolver(formSchema),
    defaultValues,
    mode: "onChange",
  });
  const { setValue: setValueUpdate, reset: resetUpdateForm } =
    methodsOfUseFormUpdate;

  // useEffect(() => {
  //   methodsOfUseFormUpdate.reset(defaultValues);
  // }, [defaultValues]);

  useEffect(() => {
    if (sellerResponding || editing) {
      // feesList in methodsOfUseForm
      const feesFormValues = methodsOfUseForm.getValues();
      if (!feesFormValues.feesList) {
        const taxExemptValue = sampleRequest.is_tax_exempt;
        const feesList =
          !taxExemptValue && !sampleRequest.fees?.length
            ? [{ name: "Tax", amount: 0, id: "tax_fee" }]
            : get_fees_list(fees_and_charges_map, sampleRequest.fees ?? []);
        setValue("feesList", feesList);
      }

      // delivery_term, payment_term, payment_method in methodsOfUseFormUpdate
      if (
        !sampleRequest.delivery_term &&
        customerSettings?.default_delivery_term
      ) {
        setValueUpdate(
          "delivery_term",
          convertDeliveryTermToOption(customerSettings?.default_delivery_term)
        );
      }
      if (
        !sampleRequest.payment_term &&
        customerSettings?.default_payment_term
      ) {
        setValueUpdate(
          "payment_term",
          convertPaymentTermToOption(customerSettings.default_payment_term)
        );
      }
      if (
        !sampleRequest.payment_method &&
        customerSettings?.default_payment_mode
      ) {
        setValueUpdate(
          "payment_method",
          convertPaymentModeToOption(customerSettings.default_payment_mode)
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    editing,
    enablePayments,
    sellerResponding,
    sampleRequest.is_tax_exempt,
    sampleRequest.fees,
    sampleRequest.delivery_term,
    sampleRequest.payment_term,
    sampleRequest.payment_method,
    customerSettings?.default_delivery_term,
    setValue,
    setValueUpdate,
    customerSettings?.default_payment_term,
    customerSettings?.default_payment_mode,
  ]);

  const {
    formState: formStateUpdate,
    handleSubmit: handleSubmitUpdate,
    watch,
    trigger,
  } = methodsOfUseFormUpdate;

  const removeCartItem = async (itemToRemove: SampleRequestDetail) => {
    // If a buyer removes the last item from the request, the backend
    // automatically transitions it to "cancelled" status.
    try {
      await Axios.delete(
        endpoints.v1_storefronts_id_sampleRequests_id_items_id(
          storefront_id,
          sampleRequest.id,
          itemToRemove.id
        )
      );
      notifySuccess(t("The item has been deleted successfully"));
      mutateSampleRequestAndEvents();
    } catch (error) {
      notifyError(t("There was an error deleting the item"), { error });
    }
  };

  const onSubmit = async (values: SampleresponseForm) => {
    try {
      const feesFormValues = methodsOfUseForm.getValues();
      const patchRecipes = sampleRequest.items.map((item) => {
        const skuOption = values[makeInputIdSku(item.id)];
        const no_of_units = values[makeInputIdNumberOfUnits(item.id)];
        const no_of_units_string =
          typeof no_of_units === "string" ? no_of_units : null;
        const price_per_unit = values[makeInputIdPricePerUnit(item.id)];
        const item_id = item.id;

        const skuOptionOption =
          typeof skuOption === "object" && "id" in skuOption.value
            ? (skuOption as OptionType<ProductSKU>)
            : null;

        const sku_id = skuOptionOption?.value.id;
        const price =
          typeof price_per_unit === "string" && price_per_unit !== ""
            ? price_per_unit
            : undefined;

        return {
          sku_id,
          ...(no_of_units_string && {
            no_of_units: no_of_units_string,
            sample_quantity: String(
              calculateTotalQuantity(
                skuOptionOption?.value.package_volume ??
                  item.sku?.package_volume ??
                  0,
                no_of_units_string
              )
            ),
          }),
          total_quantity: item.total_quantity,
          item_id,
          ...(enablePayments && price ? { price_per_unit: price } : {}),
        };
      });

      const hasPricing = sampleRequest.enable_payments || enablePayments;

      const patchData = {
        data: patchRecipes,
        ...(enable_payments_on_sample_requests
          ? { enable_payments: enablePayments }
          : {}),
      };

      if (hasPricing) {
        await Promise.all(
          patchRecipes.map((recipe) =>
            Axios.patch(
              endpoints.v1_storefronts_id_sampleRequests_id_items_id(
                storefront_id,
                sampleRequest.id,
                recipe.item_id
              ),
              recipe
            )
          )
        );
        await Axios.patch(
          `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/respond`,
          {
            delivery_term_id: values.delivery_term.value,
            payment_term_id: values.payment_term.value,
            payment_method_id: values.payment_method.value,
            valid_to_date: values.valid_to_date,
            required_eta: values.required_eta,
            enable_payments: enablePayments,
            ...(feesFormValues.feesList
              ? {
                  fees_to_add: feesFormValues.feesList.reduce(
                    (fees: Fee[], fee: any) => {
                      if (fee.amount) {
                        const { id, name, amount } = fee;

                        fees.push({
                          id,
                          name,
                          amount,
                          currency:
                            sampleRequest.currency || ("USD" as CurrencyCode),
                        });
                      }

                      return fees;
                    },
                    []
                  ),
                }
              : {}),
          }
        );

        notifySuccess(t("The sample request price was sent"));
      } else {
        await Axios.patch(
          `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/accept`,
          patchData
        );
        notifySuccess(t("The sample request was accepted"));
      }
      mutateSampleRequestAndEvents();
      setEditing(false);
    } catch (error) {
      notifyError(t("There was an error updating the sample request"), {
        error,
      });
    }
  };

  /**
   * Sellers can reject a sample request.
   */
  const rejectSampleRequest = async () => {
    try {
      await Axios.patch(
        endpoints.v1_storefronts_id_sampleRequests_id_action(
          storefront_id,
          sampleRequest.id,
          "reject"
        )
      );
      notifySuccess(t("The sample request was rejected"));
      mutateSampleRequestAndEvents();
    } catch (error) {
      notifyError(t("There was an error rejecting the sample request"), {
        error,
      });
    }
  };

  /**
   * Buyers can cancel a sample request.
   */
  const cancelSampleRequest = async () => {
    try {
      await Axios.patch(
        endpoints.v1_storefronts_id_sampleRequests_id_action(
          storefront_id,
          sampleRequest.id,
          "cancel"
        )
      );
      notifySuccess(t("The sample request was cancelled"));
      mutateSampleRequestAndEvents();
    } catch (error) {
      notifyError(t("There was an error canceling the sample request"), {
        error,
      });
    }
  };

  const showDeleteItemButton =
    !sampleRequest.enable_payments &&
    roleIsSomeKindOfBuyer &&
    (sampleRequest.status === "requested" || sampleRequest.status === "new");

  const sampleRequestCanBeSplit =
    sampleRequest.status !== "completed" &&
    sampleRequest.status !== "cancelled" &&
    sampleRequest.status !== "rejected" &&
    !sampleRequest.status.includes("pending") &&
    sampleRequest.items.length > 1 &&
    roleIsSomeKindOfSeller;

  const updateSampleStatusAndCloseDialogBox = async () => {
    setShowStatusChangeDialogBox(false);
    try {
      await Axios.patch(
        endpoints.v1_storefronts_id_sampleRequests_id_action(
          storefront_id,
          sampleRequest.id,
          convertSampleStatusToSampleStatusAction(selectedSampleStatus!)
        )
      );
      await mutateSampleRequestAndEvents();
    } catch (error) {
      const message = (error as AxiosError)?.response?.data?.message
        ? (error as AxiosError)?.response?.data?.message
        : t("There was an error updating the sample status");
      notifyError(message as string, { error });
      setSelectedSampleStatus(sampleRequest.status);
    }
  };

  const closeSampleStatusDialog = () => {
    setShowStatusChangeDialogBox(false);
    setSelectedSampleStatus(sampleRequest.status);
  };

  const handleSellerStatusChange = (label: SampleStatusLabel) => {
    const status = convertSampleLabelToSampleStatus(label);
    if (status !== sampleRequest.status && status !== selectedSampleStatus) {
      setShowStatusChangeDialogBox(true);
      setSelectedSampleStatus(status);
    }
  };

  let accountManagerContactInfo: AccountManagerContactInfo | undefined =
    undefined;
  if (sampleRequest && sampleRequest.sold_by) {
    accountManagerContactInfo = sampleRequest.sold_by.tenant_user_contact_info;
  }

  const canShowStatusPath = () =>
    sampleRequest.status !== "rejected" &&
    sampleRequest.status !== "cancelled" &&
    sampleRequest.status !== "pending_cancellation";

  const has_unlisted_products = sampleRequest.items.some(
    (product) => !product.product_id
  );

  const isNewRequest =
    ["new", "responded"].includes(sampleRequest.status) &&
    !sampleRequest.status.includes("pending");

  const showInvoiceSection =
    !isNewRequest &&
    !isPendingStatus &&
    sampleRequestIsPriced(sampleRequest) &&
    enable_payments_on_sample_requests;

  const canEditInvoice =
    sampleRequest.status !== "completed" &&
    sampleRequest.status !== "rejected" &&
    sampleRequest.status !== "cancelled" &&
    sampleRequest.status !== "payment_received" &&
    sampleRequest.status !== "shipped" &&
    showInvoiceSection;

  const canEditShipmentAdvice =
    sampleRequest.status !== "completed" &&
    sampleRequest.status !== "rejected" &&
    sampleRequest.status !== "cancelled" &&
    sampleRequest.status !== "payment_received" &&
    sampleRequest.status !== "shipped" &&
    !isNewRequest;

  const canEditPackagingList =
    sampleRequest.status !== "completed" &&
    sampleRequest.status !== "rejected" &&
    sampleRequest.status !== "cancelled" &&
    sampleRequest.status !== "payment_received" &&
    sampleRequest.status !== "shipped" &&
    !isNewRequest;

  const canShowStatusDropdown = () =>
    sampleRequest.status !== "new" &&
    sampleRequest.status !== "completed" &&
    !sampleRequest.status.includes("pending") &&
    !has_unlisted_products &&
    roleIsSomeKindOfSeller;

  const canShowDeclineAcceptButton = () =>
    roleIsSomeKindOfSeller &&
    (isPendingStatus ||
      (isBuyerSubmittedPricedSample &&
        (sampleRequest.status === "requested" ||
          sampleRequest.status === "new" ||
          (isPricedSample && editing))));

  const acceptButtonDisabled = sampleRequest.status.includes("pending");

  const confirmSampleStatusChangeMessage =
    selectedSampleStatus !== "completed"
      ? t("Are you sure you want to change the status to {{sampleStatus}}?", {
          sampleStatus: convertSampleStatusToSampleLabel(
            // there will always be selectedSampleStatus at this point
            // But this is to satisfy typescript
            selectedSampleStatus ?? "accepted"
          ),
        })
      : ((
          <>
            {t("Are you sure you want to change the status to Completed?")}
            <WarningText>
              {t(
                "There will be no further changes allowed in any of the sections"
              )}
            </WarningText>
          </>
        ) as unknown as string);

  const params = new URLSearchParams();
  if (query.q) {
    params.append("q", query.q);
  }
  params.append("offset", String(query?.offset ?? 0));
  params.append("perPage", String(query?.perPage ?? 10));
  ((query?.status ?? []).filter((status) => !!status) as string[]).forEach(
    (status) => params.append("status", status)
  );
  (
    (query?.account_manager ?? []).filter(
      (account_manager) => !!account_manager
    ) as string[]
  ).forEach((account_manager) =>
    params.append("account_manager", account_manager)
  );
  (
    (query?.customer_service_reps ?? []).filter(
      (customer_service_rep) => !!customer_service_rep
    ) as string[]
  ).forEach((customer_service_rep) =>
    params.append("customer_service_reps", customer_service_rep)
  );
  const [formattedStatusNames, setFormattedStatusNames] = useState<string[]>(
    []
  );

  const statusOrder = [
    "new",
    "responded",
    "accepted",
    "in_progress",
    "invoiced",
    "shipped",
    "completed",
  ];
  useSWR<SampleRequestNextStatusSchema, AxiosError>(
    sampleRequest.status
      ? `/v1/storefronts/sample-requests/${sampleRequest.status}`
      : null,
    {
      onSuccess: (response) => {
        const sortedStatuses = response.transitions
          .filter((item) =>
            isPartManualSampleStatusChanges(
              item,
              sampleRequest.enable_payments ?? false
            )
          )
          .map((item) => convertSampleStatusToSampleLabel(item))
          .sort(
            (a, b) =>
              statusOrder.indexOf(a.toLowerCase()) -
              statusOrder.indexOf(b.toLowerCase())
          );

        setFormattedStatusNames(sortedStatuses);
      },
    }
  );

  const { data, mutate: mutateEvents } = useSWR<
    PaginatedTransactionEvents,
    AxiosError
  >(
    sampleRequest?.id
      ? `/v1/storefronts/${storefront_id}/sample_requests/${sampleRequest.id}/events?limit=100`
      : null,
    {
      onSuccess: (events) => events.data.reverse(),
    }
  );

  const sampleEvents = data?.data;

  const last_pending_cancellation_events = sampleEvents
    ?.filter((item) => item.sample_request_action === "pending_cancellation")
    ?.pop();

  const is_cancel_requester_seller =
    last_pending_cancellation_events?.creator?.rbac_role === "seller_admin" ||
    last_pending_cancellation_events?.creator?.rbac_role === "agilis_admin";

  const mutateSampleRequestAndEvents = () => {
    return Promise.allSettled([mutateSampleRequest(), mutateEvents()]);
  };

  const isPricedSample = sampleRequestIsPriced(sampleRequest) || enablePayments;
  const [total, setTotal] = useState<number>(0);
  const [invoiceDocument, setInvoiceDocument] = useState<SampleDocument>();

  const selectedPaymentTerm = watch("payment_term") as OptionType | undefined;
  const selectedDeliveryTerm = watch("delivery_term") as OptionType | undefined;

  useEffect(() => {
    setInvoiceDocument(
      sampleRequest.documents.find((doc) => doc.kind === "invoice")
    );
  }, [sampleRequest]);

  const handleAcceptPrice = async () => {
    setIsAcceptingPrice(true);
    try {
      await Axios.patch(
        `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/accept`
      );
      notifySuccess(t("The sample request was accepted"));
      await mutateSampleRequestAndEvents();
    } catch (error) {
      notifyError(t("There was an error accepting the sample request"), {
        error,
      });
    } finally {
      setIsAcceptingPrice(false);
    }
  };

  const handlePayNow = async () => {
    setPaymentInProcess(true);
    try {
      const response = await Axios.post(
        `/v1/storefronts/${storefront_id}/sample_request/${sampleRequest.id}/payments`
      );
      if (response.data?.url) {
        window.location.href = response.data.url;
      }
    } catch (error) {
      notifyError(t("Error starting payment process"), { error });
      setPaymentInProcess(false);
    }
  };

  const maybeInvoiceCharges = sampleRequest.invoice?.additional_charges ?? [];
  const feesAndCharges = [
    ...(sampleRequest.fees ?? []),
    ...maybeInvoiceCharges,
  ];

  const sampleCurrencyTemp = useCurrency(sampleRequest.currency ?? "USD");
  const sampleCurrency = useMemo(
    () =>
      sampleCurrencyTemp ?? {
        code: sampleRequest.currency,
        symbol: MISSING_CURRENCY_SYMBOL,
        name: "--",
      },
    [sampleRequest.currency, sampleCurrencyTemp]
  );

  const { subtotalString, totalString } = calculatePriceDetails({
    items: sampleRequest.items,
    fees: feesAndCharges,
    currencyCode: sampleRequest.currency,
    totalDiscount: sampleRequest.total_discounts,
  });

  const shipmentEta = sampleRequest.required_eta
    ? moment(sampleRequest.required_eta).format("MMMM DD, YYYY")
    : "--";
  const validToDate = sampleRequest.valid_to_date
    ? moment(sampleRequest.valid_to_date).format("MMMM DD, YYYY")
    : "--";

  const sampleTerms: KeyValuePair[] = [
    ...(sampleRequest.enable_payments
      ? [
          {
            key: t("Shipping Terms"),
            value: sampleRequest.delivery_term?.name || "--",
          },
          {
            key: t("Payment Terms"),
            value: sampleRequest.payment_term?.name || "--",
          },
          {
            key: t("Shipment ETA"),
            value: shipmentEta,
          },
          {
            key: t("Payment Method"),
            value: sampleRequest.payment_method?.name || "--",
          },
          ...(validToDate
            ? [{ key: t("Price Valid Until"), value: validToDate }]
            : []),
        ]
      : []),

    {
      key: t("Decision Maker"),
      value:
        sampleRequest.is_decision_maker === true
          ? t("Yes")
          : sampleRequest.is_decision_maker === false
          ? t("No")
          : "--",
    },
    {
      key: t("Decision Timeline"),
      value: sampleRequest.decision_timeline || "--",
    },
    {
      key: t("Requested"),
      value: sampleRequest.requested_documents?.join(", ") || "--",
    },
  ];

  const showPayButton =
    isPricedSample &&
    sampleRequest.status === "invoiced" &&
    roleIsSomeKindOfBuyer &&
    sampleRequest.currency === "USD" &&
    accepts_payments &&
    Boolean(sampleRequest.payment_method?.payments_enabled);

  const poDocument = sampleRequest.documents.find(
    (doc) => doc.kind === "sample_request"
  );

  const canShowLotNumbers = ![
    "requested",
    "responded",
    "price_received",
    "new",
    "pending",
    "pending_activation",
    "rejected",
    "cancelled",
  ].includes(sampleRequest.status);

  const canEditLotNumbers =
    roleIsSomeKindOfSeller &&
    (isPricedSample
      ? !["payment_received", "shipped", "completed"].includes(
          sampleRequest.status
        )
      : !["shipped", "completed"].includes(sampleRequest.status));

  const buyerCanAcceptPricedRequest =
    roleIsSomeKindOfBuyer &&
    isPricedSample &&
    // Seller-created priced sample: buyer accepts from "new"
    ((sampleRequest.status === "new" &&
      isBuyerSubmittedPricedSample === false) ||
      // Buyer-requested, seller sent price back: buyer accepts from "price received"
      sampleRequest.buyer_status === "price_received");

  const handleSendMessage = async (message: string) => {
    try {
      await Axios.post(
        `/v1/storefronts/${storefront_id}/samples/${sampleRequest.id}/messages`,
        {
          message: message,
          message_type: "Other", // Adjust according to your API specification
        }
      );
      // Trigger a revalidation to update the list of messages
      await mutateSampleRequestAndEvents();
    } catch (error) {
      console.error(error);
      // Implement error handling, e.g., displaying a notification
    }
  };

  const tableColumns = React.useMemo<
    ColumnDef<{
      name: string;
      quantity: string;
      checkbox: string;
    }>[]
  >(
    () => [
      {
        header: "",
        width: "20px",
        accessorKey: "checkbox",
        cell: (cell) => {
          return (
            <>
              <CheckBoxNoLabel
                name={cell.getValue() as UUID}
                ref={register({
                  required: false,
                  setValueAs: (value: Array<string>) => Boolean(value.length),
                })}
                data-for="checkbox"
              />
            </>
          );
        },
      },
      {
        header: t("Name"),
        accessorKey: "name",
      },
      {
        header: t("Quantity"),
        accessorKey: "quantity",
      },
    ],
    [t, register]
  );

  const tableData = sampleRequest.items.map((item) => {
    return {
      name: item.product.name,
      quantity: `${Intl.NumberFormat("en-US").format(
        Number(item.total_quantity)
      )} ${item.total_quantity_packaging_unit?.name || ""}`,
      checkbox: item.id,
    };
  });

  const onSplitSampleRequest = async (values: Record<UUID, boolean>) => {
    set_is_splitting_sample(true);
    try {
      const itemsToSplit = Object.entries(values).reduce<UUID[]>(
        (accumulator, [key, value]) => {
          if (value) {
            accumulator.push(key);
          }
          return accumulator;
        },
        []
      );

      const res: { data: { id: UUID } } = await axios.post(
        `/v1/storefronts/${storefront_id}/samples/${sampleRequest.id}/split`,
        { item_ids: itemsToSplit }
      );
      notifySuccess(t("Sample request split successfully"));
      set_is_splitting_sample(false);
      history.push(`${accountPath}/samples/${res.data.id}`);
    } catch (error) {
      notifyError(t("There was an error splitting the Sample Request"));
      set_is_splitting_sample(false);
    }
  };

  // const handleOverrideAccept = async () => {
  //   try {
  //     await Axios.patch(
  //       `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/accept`
  //     );
  //     notifySuccess(t("The sample request was accepted"));
  //     mutateSampleRequestAndEvents();
  //   } catch (error) {
  //     notifyError(t("There was an error accepting the sample request"), {
  //       error,
  //     });
  //   }
  // };
  const handleOverRide = async (handleSubmit: any) => {
    const isValid = await trigger();
    if (isValid) {
      handleSubmit();
    }
  };
  const handleCancelTransaction = async (values: {
    reasonForCancellation: string;
  }) => {
    const cancellationData =
      sampleRequest.status !== "pending_cancellation"
        ? {
            cancellation_reason: values.reasonForCancellation,
            previous_status: sampleRequest.status,
          }
        : null;

    try {
      set_is_cancelling_transaction(true);
      await Axios.patch(
        `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/cancel`,
        cancellationData
      );
      notifySuccess(
        `Sample Request ${sampleRequest.number} ${
          sampleRequest.status === "pending_cancellation"
            ? "is cancelled."
            : "request for cancellation."
        }`
      );
      await mutateSampleRequestAndEvents();
    } catch (error) {
      const message = (error as AxiosError)?.response?.data?.message
        ? (error as AxiosError)?.response?.data?.message
        : t("There was an error cancelling the sample request");
      notifyError(message as string, { error });
    } finally {
      set_is_cancelling_transaction(false);
    }
  };

  const handleResumeSampleRequest = async () => {
    set_is_resuming_transaction(true);
    try {
      await Axios.patch(
        `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/resume_sample`
      );
      notifySuccess(
        `Sample request ${sampleRequest.number} is successfully resumed.`
      );
      await mutateSampleRequestAndEvents();
    } catch (error) {
      const message = (error as AxiosError)?.response?.data?.message
        ? (error as AxiosError)?.response?.data?.message
        : t("There was an error resuming the sample request");
      notifyError(message as string, { error });
    } finally {
      set_is_resuming_transaction(false);
    }
  };

  const getRequestedByAddress: IAddress | undefined = (() => {
    return {
      ...(sampleRequest.requested_by ? sampleRequest.requested_by : {}),
      ...(sampleRequest.requested_by_hq_address
        ? sampleRequest.requested_by_hq_address
        : {}),
    } as IAddress;
  })();

  const showTotalsection =
    isBuyerSubmittedPricedSample && roleIsSomeKindOfSeller
      ? isPricedSample
      : sampleRequestIsPriced(sampleRequest);

  // Unpriced samples
  const canCancelTransactionStatus: SampleRequestStatus[] = [
    "accepted",
    "in_progress",
  ];

  // Priced samples
  const canCancelPricedTransactionStatus: SampleRequestStatus[] = [
    "accepted",
    "in_progress",
    "invoiced",
    "shipped",
  ];

  const isPersistedPricedSample = sampleRequestIsPriced(sampleRequest);

  // null until events have loaded, so nobody sees a confirm button by mistake
  const cancel_requester: "seller" | "buyer" | null =
    last_pending_cancellation_events
      ? is_cancel_requester_seller
        ? "seller"
        : "buyer"
      : null;

  // Only the party that did NOT request can confirm
  const can_confirm_cancellation_priced =
    sampleRequest.status === "pending_cancellation" &&
    ((cancel_requester === "seller" && roleIsSomeKindOfBuyer) ||
      (cancel_requester === "buyer" && roleIsSomeKindOfSeller));

  const can_cancel_after_accepting = isPersistedPricedSample
    ? !accepts_payments &&
      (canCancelPricedTransactionStatus.includes(sampleRequest.status) ||
        can_confirm_cancellation_priced)
    : canCancelTransactionStatus.includes(sampleRequest.status) ||
      (sampleRequest.status === "pending_cancellation" &&
        ((is_cancel_requester_seller && roleIsSomeKindOfBuyer) ||
          (!is_cancel_requester_seller && roleIsSomeKindOfSeller)));

  return (
    <PageWrapper>
      <Link to={`${accountPath}/samples?${params}`}>
        <LinkButtonLargeV2>
          <CaretLeft fill="currentColor" />
          {t("Sample Requests")}
        </LinkButtonLargeV2>
      </Link>
      <PageHeader>
        <HeaderLeft>
          <PageTitle>{t("Sample Request")}</PageTitle>
          <IDDesktop>{`${sampleRequest.number}`}</IDDesktop>
        </HeaderLeft>
        <HeaderRight data-testid={"quote-detail-status-container"}>
          <SampleRequestStatusLabel status={sampleRequest.status} t={t} />
        </HeaderRight>
      </PageHeader>
      <Flex>
        <SoftHeader style={{ margin: `0 ${spacingTokens.spacing_xxs} 5px 0` }}>
          {t("Created By")}:
        </SoftHeader>
        <SoftHeaderPrimaryTextColor>
          {`${sampleRequest.created_by || `--`} (${
            sampleRequest.created_by_company_name
          })`}
        </SoftHeaderPrimaryTextColor>
      </Flex>
      <Flex>
        <SoftHeader style={{ margin: `0 ${spacingTokens.spacing_xxs} 0 0` }}>
          {t("Created On")}:
        </SoftHeader>
        <SoftHeaderPrimaryTextColor>
          {formatDateTime(sampleRequest.created_at) || `--`}{" "}
        </SoftHeaderPrimaryTextColor>
        {(formatDateTime(sampleRequest.modified_at) !==
          formatDateTime(sampleRequest.created_at) ||
          sampleRequest.created_by !== sampleRequest.modified_by) && (
          <>
            <SoftHeader
              style={{ margin: `0 ${spacingTokens.spacing_xxs} 0 10px` }}
            >
              {t("Last Modified")}:
            </SoftHeader>
            <SoftHeaderPrimaryTextColor>
              {sampleRequest.modified_at
                ? `${formatDateTime(sampleRequest.modified_at)} By ${
                    sampleRequest.modified_by
                  }`
                : `--`}
            </SoftHeaderPrimaryTextColor>
          </>
        )}
      </Flex>
      <HorizontalSeparator />
      <DetailPageContentWrapper>
        <SampleRequestContent>
          {canShowStatusPath() && (
            <StatusContainer style={{ position: "relative", zIndex: 1 }}>
              <TransactionStatusPath
                transactionStatus={sampleRequest.status}
                view={roleIsSomeKindOfBuyer ? "buyerSample" : "sellerSample"}
                isPricedSample={sampleRequestIsPriced(sampleRequest)}
                isBuyerSubmittedPricedSample={
                  isBuyerSubmittedPricedSample &&
                  sampleRequestIsPriced(sampleRequest)
                }
              />
              {canShowStatusDropdown() && formattedStatusNames && (
                <DropDown
                  items={formattedStatusNames}
                  className="order_status"
                  activeItem={convertSampleStatusToSampleLabel(
                    sampleRequest.status,
                    roleIsSomeKindOfSeller
                  )}
                  direction={"left"}
                  clickHandler={handleSellerStatusChange}
                  showIcon
                  placeholder={t("Change status")}
                />
              )}
              <ConfirmDialog
                show={showStatusChangeDialogBox}
                confirmMessage={confirmSampleStatusChangeMessage}
                closeDialog={closeSampleStatusDialog}
                handleConfirm={updateSampleStatusAndCloseDialogBox}
              />
            </StatusContainer>
          )}
          <Card style={{ zIndex: 0 }}>
            <PageHeader>
              <HeaderLeft>
                <H3>{t("Details")}</H3>
              </HeaderLeft>
              <HeaderRight>
                {sampleRequestCanBeSplit && !editing && (
                  <PrimaryButtonMedium
                    onClick={() => setShowSplitSampleForm(true)}
                  >
                    {t("Split Sample Request")}
                  </PrimaryButtonMedium>
                )}
                {roleIsSomeKindOfSeller &&
                  sampleRequest.status === "responded" &&
                  !editing && (
                    <GhostButtonMediumV2
                      type="button"
                      onClick={() => {
                        resetUpdateForm({
                          ...defaultValues,
                        });

                        resetFeesForm({
                          feesList: get_fees_list(
                            fees_and_charges_map,
                            sampleRequest.fees ?? []
                          ),
                        });

                        setEditing(true);
                      }}
                    >
                      {t("Edit and Resend")}
                    </GhostButtonMediumV2>
                  )}
                {editing && (
                  <CancelButton type="button" onClick={() => setEditing(false)}>
                    {t("Cancel")}
                  </CancelButton>
                )}
              </HeaderRight>
            </PageHeader>
            <HorizontalSeparator />
            <WideDetails>
              <ContactInfoBlockSmall
                address={sampleRequest.shipping_address}
                pointOfContact={sampleRequest.shipping_point_of_contact}
                header={t("Ship to")}
                testid={"shipping-address"}
              />
              <ContactInfoBlockSmall
                address={sampleRequest.seller_address}
                accountManagerContactInfo={accountManagerContactInfo}
                header={t("Sold by")}
                testid={"sold-by-address"}
              />
              <ContactInfoBlockSmall
                address={getRequestedByAddress}
                accountManagerContactInfo={
                  sampleRequest.requested_by as
                    | AccountManagerContactInfo
                    | undefined
                }
                header={t("Requested By")}
                testid={"requested-by-address"}
              />
            </WideDetails>
            {!sampleRequest.is_buyer_activated && (
              <NotificationContainer>
                <WarningIcon width={18} height={18} />
                <ActiveWarningMessage>
                  {t(
                    `${sampleRequest.buyer_company_name} has not activated their account yet, and will not receive any updates until their account is verified`
                  )}
                </ActiveWarningMessage>
              </NotificationContainer>
            )}
            <FormProvider {...methodsOfUseFormUpdate}>
              <Form onSubmit={handleSubmitUpdate(onSubmit)}>
                {roleIsSomeKindOfSeller &&
                  isBuyerSubmittedPricedSample &&
                  enable_payments_on_sample_requests &&
                  (sellerResponding ||
                    (sampleRequest.status !== "responded" && editing)) && (
                    <Row
                      style={{
                        gap: spacingTokens.spacing_md,
                        alignItems: "center",
                        marginBottom: spacingTokens.spacing_xl,
                      }}
                    >
                      <ToggleSwitchV2
                        checked={enablePayments}
                        label="Enable Payments"
                        onChange={() => setEnablePayments((prev) => !prev)}
                      />
                    </Row>
                  )}
                {roleIsSomeKindOfSeller &&
                  enablePayments &&
                  isBuyerSubmittedPricedSample &&
                  (sellerResponding || editing) && (
                    <>
                      <H3>{t("Your terms")}</H3>
                      <div
                        style={{
                          maxWidth: "450px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "10px",
                        }}
                      >
                        <CreateSampleTermsForm
                          isTaxExempt={customerSettings?.is_tax_exempt ?? false}
                          defaultPaymentMethod={
                            customerSettings?.default_payment_mode
                              ? convertPaymentModeToOption(
                                  customerSettings.default_payment_mode
                                )
                              : null
                          }
                          defaultDeliveryTerm={
                            customerSettings?.default_delivery_term
                              ? convertDeliveryTermToOption(
                                  customerSettings.default_delivery_term
                                )
                              : null
                          }
                          defaultPaymentTerm={
                            customerSettings?.default_payment_term
                              ? convertPaymentTermToOption(
                                  customerSettings.default_payment_term
                                )
                              : null
                          }
                        />
                      </div>
                    </>
                  )}
                <H3>{t("Items")}</H3>
                <ItemsContainer>
                  {roleIsSomeKindOfSeller &&
                    (sellerResponding || editing) &&
                    sampleRequest.items.map((item, index) => {
                      return (
                        <SampleRequestItemCardSellerResponding
                          sample={sampleRequest}
                          key={item.id + index}
                          item={item}
                          index={index}
                          methodsOfUseForm={methodsOfUseFormUpdate}
                          inputIdSku={makeInputIdSku(item.id)}
                          inputIdCustomSku={makeInputIdCustomSku(item.id)}
                          inputIdNumberOfUnits={makeInputIdNumberOfUnits(
                            item.id
                          )}
                          inputIdPricePerUnit={makeInputIdPricePerUnit(item.id)}
                          enablePayments={enablePayments}
                          isBuyerSubmittedPricedSample={
                            isBuyerSubmittedPricedSample
                          }
                          itemDetail={itemDetailRecord[item.id]}
                          propagateItemDetails={(record) => {
                            setItemDetailRecord((previous) => ({
                              ...previous,
                              ...record,
                            }));
                          }}
                          deliveryTermId={selectedDeliveryTerm?.value}
                          paymentTermId={selectedPaymentTerm?.value}
                        />
                      );
                    })}
                  {roleIsSomeKindOfBuyer &&
                    (sampleRequest.status === "requested" ||
                      sampleRequest.status === "new" ||
                      sampleRequest.status === "responded") &&
                    sampleRequest.items.map((item, index) => {
                      return (
                        <SampleRequestItem
                          item={item}
                          handleConfirmDelete={
                            showDeleteItemButton
                              ? () => removeCartItem(item)
                              : undefined
                          }
                          index={index}
                          key={index}
                          sample={sampleRequest}
                        />
                      );
                    })}

                  {(roleIsSomeKindOfBuyer || roleIsSomeKindOfSeller) &&
                    !sampleRequestIsPriced(sampleRequest) &&
                    (sampleRequest.status === "new" ||
                      sampleRequest.status === "requested" ||
                      sampleRequest.status === "responded") && (
                      <PrimaryButtonWithPlusIcon
                        type="button"
                        onClick={() => setShowAddProductForm(true)}
                      >
                        {t("Add Product")}
                      </PrimaryButtonWithPlusIcon>
                    )}

                  {sellerComplete &&
                    !editing &&
                    !(
                      roleIsSomeKindOfBuyer &&
                      (sampleRequest.status === "requested" ||
                        sampleRequest.status === "new" ||
                        sampleRequest.status === "responded")
                    ) &&
                    sampleRequest.items.map((item, index) => {
                      return (
                        <SampleRequestItem
                          item={item}
                          handleConfirmDelete={
                            showDeleteItemButton
                              ? () => removeCartItem(item)
                              : undefined
                          }
                          index={index}
                          key={index}
                          sample={sampleRequest}
                        />
                      );
                    })}
                </ItemsContainer>

                <TwoColumnOrderTotalSection>
                  <QuoteTermsContainer>
                    <KeyValueContainer>
                      <KeyValueDisplay data={sampleTerms} />
                    </KeyValueContainer>
                  </QuoteTermsContainer>
                  {showTotalsection && (
                    <PriceDetailsColumn>
                      {(isBuyerSubmittedPricedSample &&
                        roleIsSomeKindOfSeller &&
                        sellerResponding) ||
                      editing ? (
                        <EditSubtotal
                          subtotal={calculateSubtotal(itemDetailRecord)}
                          total={total}
                          isTaxExempt={
                            editing
                              ? Boolean(sampleRequest.is_tax_exempt)
                              : customerSettings?.is_tax_exempt ?? false
                          }
                          setTotal={setTotal}
                          methodsOfUseForm={methodsOfUseForm}
                          currency={sampleCurrency}
                          showDiscountCode={false}
                          buyerTenantId={sampleRequest.buyer_id}
                        />
                      ) : (
                        <PriceDetails
                          subtotal={subtotalString}
                          total={totalString}
                          fees={feesAndCharges}
                          currencyCode={sampleRequest.currency}
                          payment={
                            roleIsSomeKindOfSeller
                              ? sampleRequest.payments
                              : undefined
                          }
                          showDiscountCode={false}
                          buyerTenantId={sampleRequest.buyer_id}
                        />
                      )}
                      {buyerCanAcceptPricedRequest && (
                        <PrimaryButtonFitContainer
                          type="button"
                          loading={isAcceptingPrice}
                          onClick={handleAcceptPrice}
                        >
                          {sampleRequest.status === "responded"
                            ? t("Accept Price")
                            : t("Accept")}
                        </PrimaryButtonFitContainer>
                      )}
                      {showPayButton && (
                        <PrimaryButtonLargeV2
                          type="button"
                          fullWidth
                          loading={paymentInProcess}
                          onClick={handlePayNow}
                          disabled={!enable_payments_on_sample_requests}
                        >
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "center",
                              gap: spacingTokens.spacing_xs,
                              alignItems: "center",
                            }}
                          >
                            <img
                              src="https://cdn.agilischemicals.com/assets/Agilis_Logo_rainbow.svg"
                              width="27"
                              style={{
                                verticalAlign: "middle",
                                marginBottom: "3px",
                              }}
                              alt="Agilis Logo"
                            />
                            <span> {t("Pay Now")}</span>
                          </div>
                        </PrimaryButtonLargeV2>
                      )}
                    </PriceDetailsColumn>
                  )}
                </TwoColumnOrderTotalSection>

                {canShowDeclineAcceptButton() && (
                  <ButtonRow>
                    <ButtonWithConfirmDialog
                      Button={(props: SVGButtonProps) => (
                        <CancelButton {...props} style={{ padding: "0" }}>
                          {t("Decline sample request")}
                        </CancelButton>
                      )}
                      testid={"sample-request-reject-button"}
                      handleConfirm={rejectSampleRequest}
                      confirmMessage={t(
                        "Are you sure you want to reject this sample request?"
                      )}
                    />
                    {!acceptButtonDisabled && isBuyerSubmittedPricedSample ? (
                      <PrimaryButtonFitContainer
                        type="submit"
                        disabled={acceptButtonDisabled}
                        datafor="accept_button_disabled"
                        datatip={
                          acceptButtonDisabled
                            ? t("Awaiting buyer activation")
                            : ""
                        }
                        style={{ maxWidth: "340px" }}
                        loading={formStateUpdate.isSubmitting}
                      >
                        {enablePayments ? t("Send Price") : t("Accept")}
                      </PrimaryButtonFitContainer>
                    ) : (
                      <ButtonWithWarningDialog
                        Button={(props) => (
                          <>
                            <PrimaryButtonFitContainer
                              type="button"
                              style={{ maxWidth: "340px" }}
                              datafor="account_activation_button"
                              datatip="Awaiting buyer account activation"
                              onClick={() => handleOverRide(props.onClick)}
                            >
                              {enablePayments ? t("Send Price") : t("Accept")}
                            </PrimaryButtonFitContainer>
                            <ReactTooltip
                              id="account_activation_button"
                              effect="solid"
                            />
                          </>
                        )}
                        testid={`close_upload`}
                        confirmMessage={t(
                          `Accepting this Sample Request will override the account activation process for ${sampleRequest.buyer_company_name}. ${sampleRequest.buyer_company_name} will not be notified of any updates until they verify their account details.`
                        )}
                        handleConfirm={handleSubmitUpdate(onSubmit)}
                        heading={t("Override Sample Request")}
                        showSecondButton={true}
                        saveBtnTitle={t("Override & Accept")}
                        showAlignCloseButton={true}
                        isSmallErrorMsgStyle={true}
                      />
                    )}
                  </ButtonRow>
                )}
                {(sampleRequest.status === "requested" ||
                  sampleRequest.status === "new" ||
                  sampleRequest.status === "price_received") &&
                  roleIsSomeKindOfBuyer && (
                    <ButtonRow>
                      <ButtonWithConfirmDialog
                        Button={(props: SVGButtonProps) => (
                          <CancelButton {...props} style={{ padding: "0" }}>
                            {t("Cancel Request")}
                          </CancelButton>
                        )}
                        testid={"sample-request-cancel-button"}
                        handleConfirm={cancelSampleRequest}
                        confirmMessage={t(
                          "Are you sure you want to cancel this sample request?"
                        )}
                      />
                    </ButtonRow>
                  )}
                {sampleRequest.status === "new" &&
                  !isBuyerSubmittedPricedSample &&
                  roleIsSomeKindOfSeller && (
                    <ButtonRow>
                      <ButtonWithConfirmDialog
                        Button={(props: SVGButtonProps) => (
                          <CancelButton {...props} style={{ padding: "0" }}>
                            {t("Cancel Request")}
                          </CancelButton>
                        )}
                        testid={"sample-request-cancel-button"}
                        handleConfirm={cancelSampleRequest}
                        confirmMessage={t(
                          "Are you sure you want to cancel this sample request?"
                        )}
                      />
                    </ButtonRow>
                  )}
                {can_cancel_after_accepting ||
                sampleRequest.status === "pending_cancellation" ? (
                  <ButtonRow
                    style={{
                      justifyContent:
                        sampleRequest.status === "pending_cancellation" &&
                        !can_cancel_after_accepting
                          ? "flex-end"
                          : "space-between",
                    }}
                  >
                    {can_cancel_after_accepting && (
                      <CancelTransactionDialogButton
                        Button={(props) => (
                          <CancelButton
                            style={{ padding: 0 }}
                            {...props}
                            type={"button"}
                            loading={is_cancelling_transaction}
                          >
                            {t("Cancel")}
                          </CancelButton>
                        )}
                        type="button"
                        testid={"sample-transaction-cancel-button"}
                        handleConfirm={handleCancelTransaction}
                        confirmMessage={
                          sampleRequest.status === "pending_cancellation"
                            ? t(
                                "{{requester}} has requested this sample to be cancelled. Please confirm if you would like to cancel the sample request.",
                                {
                                  requester: roleIsSomeKindOfBuyer
                                    ? "Seller"
                                    : "Buyer",
                                }
                              )
                            : t(
                                "Cancelling this sample request will require approval from {{confirmer}}, and cannot be undone. Please confirm if you would like to proceed and provide a reason for cancellation.",
                                {
                                  confirmer: roleIsSomeKindOfBuyer
                                    ? "Seller"
                                    : "Buyer",
                                }
                              )
                        }
                        heading={t("Cancel Transaction")}
                        cancellationReason={sampleRequest?.cancellation_reason}
                        isCancellationPending={
                          sampleRequest.status === "pending_cancellation"
                        }
                      />
                    )}
                    {sampleRequest.status === "pending_cancellation" && (
                      <PrimaryButtonFitContainer
                        style={{ maxWidth: "340px" }}
                        type="button"
                        loading={is_resuming_transaction}
                        onClick={handleResumeSampleRequest}
                      >
                        {t("Resume Sample")}
                      </PrimaryButtonFitContainer>
                    )}
                  </ButtonRow>
                ) : (
                  <></>
                )}
              </Form>
            </FormProvider>
          </Card>

          {showInvoiceSection && roleIsSomeKindOfSeller && (
            <Card>
              {!canEditInvoice ? (
                <InvoiceSection
                  orderOrSample={sampleRequest}
                  type="sample_requests"
                  readOnly={true}
                />
              ) : (
                <InvoiceSection
                  orderOrSample={sampleRequest}
                  readOnly={false}
                  type="sample_requests"
                  mutateOrderAndEvents={mutateSampleRequestAndEvents}
                />
              )}
            </Card>
          )}
          {canShowLotNumbers && (
            <Card>
              <Row>
                <H3>{t("Lot Number")}</H3>
                {showEditLotNumber && (
                  <CancelButton
                    onClick={() => {
                      setShowEditLotNumber(false);
                      mutateSampleRequest();
                    }}
                  >
                    {t("Cancel")}
                  </CancelButton>
                )}
                {!showEditLotNumber &&
                  canEditLotNumbers &&
                  (!sampleRequest.items.some(
                    (item) => (item.lot_numbers?.length ?? 0) > 0
                  ) ? (
                    <PrimaryButtonMediumV2
                      onClick={() => setShowEditLotNumber(true)}
                    >
                      {t("Add")}
                    </PrimaryButtonMediumV2>
                  ) : (
                    <EditButton
                      testid="editSampleLotNumber"
                      onClick={() => setShowEditLotNumber(true)}
                    />
                  ))}
              </Row>
              <DisplayOrEditLotNumbers
                orderItems={sampleRequest.items.map((item) => ({
                  id: item.id,
                  no_of_units: item.no_of_units,
                  sku: item.sku,
                  product: item.product,
                  product_applications: item.applications,
                  lot_numbers: item.lot_numbers ?? [],
                }))}
                orderId={sampleRequest.id}
                editMode={showEditLotNumber && canEditLotNumbers}
                handleSave={() => {
                  setShowEditLotNumber(false);
                  mutateSampleRequest();
                }}
                transactionType="sample_requests"
                emptyMessage={t("No Lot Number Available")}
              />
            </Card>
          )}

          {sampleRequest.alternative_po_number && roleIsSomeKindOfSeller && (
            <Card>
              <H3>{t("PO Number")}</H3>
              <PoNumberAndDocumentLink
                poNumber={sampleRequest.alternative_po_number}
                poDocument={poDocument}
              />
            </Card>
          )}

          {roleIsSomeKindOfBuyer && (
            <Card>
              <AddPO
                orderOrSample={sampleRequest}
                transactionType="sample-requests"
                mutateTypeAndEvents={mutateSampleRequestAndEvents}
              />
            </Card>
          )}

          {sampleRequest.alternative_po_number && roleIsSomeKindOfBuyer && (
            <Card>
              <PackingListSection
                order={sampleRequest}
                readOnly={true}
                mutateOrderAndEvents={mutateSampleRequestAndEvents}
                transactionType="sample-requests"
              />
            </Card>
          )}

          {sampleRequest.alternative_po_number &&
            !isNewSample &&
            roleIsSomeKindOfSeller && (
              <Card>
                <PackingListSection
                  order={sampleRequest}
                  readOnly={!canEditPackagingList}
                  mutateOrderAndEvents={mutateSampleRequestAndEvents}
                  transactionType="sample-requests"
                />
              </Card>
            )}
          {sampleRequest.payments?.receipt_url && roleIsSomeKindOfBuyer && (
            <Card>
              <InnerTitle>{t("Receipt")}</InnerTitle>
              <div
                style={{
                  display: "flex",
                  position: "relative",
                  alignItems: "center",
                }}
              >
                <a
                  href={sampleRequest.payments.receipt_url}
                  target="blank"
                  style={{
                    marginRight: spacingTokens.spacing_xxs,
                    color: theme.primaryLinkColor,
                  }}
                >
                  {sampleRequest.number} {t("receipt")}
                </a>
                <div style={{ top: "6px" }}>
                  <ExternalLinkIcon />
                </div>
              </div>
            </Card>
          )}

          {invoiceDocument && roleIsSomeKindOfBuyer && (
            <Card>
              <InvoiceSection
                type="sample_requests"
                orderOrSample={sampleRequest}
                readOnly={true}
              />
            </Card>
          )}

          {sampleRequest.status !== "requested" &&
            sampleRequest.status !== "responded" &&
            sampleRequest.status !== "new" &&
            sampleRequest.status !== "pending" &&
            sampleRequest.status !== "pending_activation" && (
              <>
                <Card>
                  <Row>
                    <H3>{t("Shipment Advice")}</H3>
                  </Row>
                  {sampleRequest.shipment_advices &&
                  sampleRequest.shipment_advices?.length > 0 ? (
                    sampleRequest.shipment_advices.map((advice) => (
                      <ShipmentAdviceSection
                        key={advice.id}
                        shipment_advice={advice}
                        orderId={sampleRequest.id}
                        isSampleRequest={true}
                        canEdit={
                          canEditShipmentAdvice && roleIsSomeKindOfSeller
                        }
                        mutateData={mutateSampleRequest}
                        handleEditShipmentAdvice={() => {
                          setAdviceToEdit(advice);
                          setShowShipmentAdviceForm(true);
                        }}
                      />
                    ))
                  ) : // If nothing has been created yet the top level object will
                  // not exist.
                  roleIsSomeKindOfBuyer ? (
                    <>{t("Shipment advice document is not available.")}</>
                  ) : (
                    <></>
                  )}
                  {roleIsSomeKindOfSeller && canEditShipmentAdvice && (
                    <Row style={{ marginTop: spacingTokens.spacing_2xl }}>
                      <PrimaryButtonMedium
                        onClick={() => {
                          setAdviceToEdit(undefined);
                          setShowShipmentAdviceForm(true);
                        }}
                      >
                        {t("Add Shipment Advice")}
                      </PrimaryButtonMedium>
                    </Row>
                  )}
                  {roleIsSomeKindOfSeller && (
                    <SlideOut
                      show={showShipmentAdviceForm}
                      closeFlyout={() => setShowShipmentAdviceForm(false)}
                      title={t("Shipment Advice")}
                    >
                      <SellerCreateOrEditShipmentAdvice
                        shipmentAdvice={adviceToEdit}
                        shippingDocument={
                          adviceToEdit?.shipment_advice_document
                        }
                        mode={adviceToEdit ? "edit" : "create"}
                        closeForm={() => {
                          setShowShipmentAdviceForm(false);
                          mutateSampleRequest();
                        }}
                        mutateData={mutateSampleRequest}
                        patchShipmentAdviceDocument={(formData) =>
                          Axios.patch(
                            `/v1/storefronts/${storefront_id}/sample-requests/${sampleRequest.id}/documents/shipping_document`,
                            formData,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            }
                          )
                        }
                        postShipmentAdvice={(formData) =>
                          Axios.post(
                            endpoints.v1_storefronts_id_sampleRequests_id_shipmentAdvice(
                              storefront_id,
                              sampleRequest.id
                            ),
                            formData,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            }
                          )
                        }
                        patchShipmentAdvice={(formData) =>
                          Axios.patch(
                            endpoints.v1_storefronts_id_sampleRequests_id_shipmentAdvice_id(
                              storefront_id,
                              sampleRequest.id,
                              adviceToEdit?.id
                            ),
                            formData,
                            {
                              headers: {
                                "Content-Type": "multipart/form-data",
                              },
                            }
                          )
                        }
                        deleteShipmentAdvice={(documentId) =>
                          Axios.delete(
                            endpoints.v1_storefronts_id_sampleRequests_id_documents_id(
                              storefront_id,
                              sampleRequest.id,
                              documentId
                            )
                          )
                        }
                      />
                    </SlideOut>
                  )}
                </Card>
              </>
            )}

          <SlideOut
            show={showAddDocumentForm}
            closeFlyout={() => setShowAddDocumentForm(false)}
            title={t("Documents")}
          >
            <AddDocumentToTransaction
              existing_documents={get_existing_documents({
                items: roleIsSomeKindOfSeller ? sampleRequest.items : [],
                seller_or_buyer_documents: roleIsSomeKindOfSeller
                  ? sampleRequest.seller_documents
                  : sampleRequest.buyer_documents,
              })}
              products={sampleRequest.items
                .filter((item) => item.product_id)
                .map(({ product: { name }, product_id }) => ({
                  name,
                  id: product_id,
                }))}
              transaction_type="sample-requests"
              transaction_type_id={sampleRequest.id}
              fetchData={mutateSampleRequest}
              onComplete={() => setShowAddDocumentForm(false)}
              onCancel={() => setShowAddDocumentForm(false)}
            />
          </SlideOut>
          {roleIsSomeKindOfSeller && (
            <SlideOut
              show={showSplitSampleForm}
              closeFlyout={() => setShowSplitSampleForm(false)}
              title={t("Split Sample Request")}
            >
              <TransactionSplitForm
                formTitle={t("Split Sample Request")}
                subtitle={t("Select Products to move to a new Sample Request")}
                buttonText={t("Split Sample Request")}
                isLoading={is_splitting_sample}
                columns={tableColumns}
                tableData={tableData}
                methodsOfUseForm={methodsOfUseForm}
                onSubmit={onSplitSampleRequest}
              />
            </SlideOut>
          )}
          <TransactionsDocumentView
            items={sampleRequest.items}
            seller_documents={sampleRequest.seller_documents}
            buyer_documents={sampleRequest.buyer_documents}
            onAddDocumentClick={() => setShowAddDocumentForm(true)}
            status={sampleRequest.status}
            buyer_role={sampleRequest.buyer_role ?? "buyer"}
          />
          {roleIsSomeKindOfSeller && (
            <TransactionNotes
              transactionType="sample"
              transactionId={sampleRequest.id}
              notes={sampleRequest.internal_notes}
              mutate={() => {
                mutateSampleRequestAndEvents();
              }}
            />
          )}
        </SampleRequestContent>
        <TimelineWrapper>
          {user && sampleEvents && sampleRequest && (
            <Timeline
              messages={sampleEvents}
              loggedInUser={user as User} // Make sure to have a logic to determine the logged-in user
              fetchingData={false}
              sendMessage={handleSendMessage}
              sampleRequest={sampleRequest}
            />
          )}
        </TimelineWrapper>
      </DetailPageContentWrapper>
      <SlideOut
        title={t("Add Product")}
        show={showAddProductForm}
        closeFlyout={() => setShowAddProductForm(false)}
      >
        <AddProductToSampleRequest
          transactionId={sampleRequest.id}
          transactionType="sample-requests"
          onComplete={() => {
            setShowAddProductForm(false);
            mutateSampleRequest();
          }}
          buyerId={sampleRequest.buyer_id}
        />
      </SlideOut>
    </PageWrapper>
  );
};
